<template>
  <div>
    <wc-section-title title='Management'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'management-base',
  computed: {
    menu () {
      return [
        {
          title: 'Management Dashboard',
          icon: this.$store.state.icons.modules.management.icon,
          route: { name: 'ManagementDashboard' }
        },
        {
          title: this.$store.state.icons.modules.financialReports.title,
          icon: this.$store.state.icons.modules.financialReports.icon,
          subRoutesMenu: [
            {
              title: this.$store.state.icons.modules.balanceSheet.title,
              icon: this.$store.state.icons.modules.balanceSheet.icon,
              route: { name: 'BalanceSheet' }
            },
            {
              title: this.$store.state.icons.modules.profitAndLoss.title,
              icon: this.$store.state.icons.modules.profitAndLoss.icon,
              route: { name: 'ProfitAndLoss' }
            },
            {
              title: this.$store.state.icons.modules.accountTransactions.title,
              icon: this.$store.state.icons.modules.accountTransactions.icon,
              route: { name: 'AccountTransactions' }
            },
            {
              title: this.$store.state.icons.modules.accountTransactionsByReconciliation.title,
              icon: this.$store.state.icons.modules.accountTransactionsByReconciliation.icon,
              route: { name: 'AccountTransactionsByReconciliation' }
            }
          ]
        },
	{
		title: "Parts Report",
		icon: 'mdi-tools',
		route: {name: "PartsReport" }
	},
        {
          title: this.$store.state.icons.modules.financialSettings.title,
          icon: this.$store.state.icons.modules.financialSettings.icon,
          subRoutesMenu: [
            {
              title: this.$store.state.icons.modules.chartOfAccounts.title,
              icon: this.$store.state.icons.modules.chartOfAccounts.icon,
              route: { name: 'ChartOfAccounts' }
            },
            {
              title: 'New ' + this.$store.state.icons.modules.journalEntry.title,
              icon: this.$store.state.icons.modules.journalEntry.icon,
              route: { name: 'CreateJournalEntry' }
            },
          ]
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Management Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
